/**
 * Версия веб-приложения. Формат: MAJOR.MINOR.PATCH.BUILD.
 * При каждом релиз-деплое инкрементировать последнее число (BUILD).
 * Major/Minor/Patch меняются вручную при значимых релизах.
 *
 * Эта константа выводится под кнопкой «Выйти» в сайдбаре.
 */
export const APP_VERSION = '1.0.1.590';
